import { render, staticRenderFns } from "./homeData.vue?vue&type=template&id=1e88c1dc&scoped=true"
import script from "./homeData.vue?vue&type=script&lang=js"
export * from "./homeData.vue?vue&type=script&lang=js"
import style0 from "./homeData.vue?vue&type=style&index=0&id=1e88c1dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e88c1dc",
  null
  
)

export default component.exports